import(/* webpackMode: "eager" */ "/vercel/path0/components/article-drawer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts/bebas-neue.ts\",\"import\":\"Bebas_Neue\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"bebasNeue\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/markdown-content/styles.module.css");
